import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import {isEmpty} from 'lodash/lang';
import {RemoveRedEye as RemoveRedEyeIcon} from '@material-ui/icons';
import {withKluwellTableWrapper, KluwellTableCore, SortingManager} from 'components/common';
import {buildUserFullName, formatDate} from 'utils/common';
import {momentDatetime} from '../../utils/common';

const buildBookRecords = (books) => {
  const sortedIds = books.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((bookId) => {
        const book = books[bookId];
        return {
          record: book,
          id: bookId,
          title: book.title,
          isbn: book.isbn,
          publisher: book.publisher,
          yearPublished: book.yearPublished,
          author: book.author,
          illustrator: book.illustrator,
          dateAdded: formatDate(book.dateAdded),
          moderated: book.moderated,
          status: book.status,
          addedBy: buildUserFullName(book.addedBy),
          actions: '',
        };
      });
};

const buildBookSettings = () => ({
  title: {
    fieldText: 'Title',
  },
  isbn: {
    fieldText: 'ISBN',
  },
  publisher: {
    fieldText: 'Publisher',
  },
  yearPublished: {
    fieldText: 'Year Published',
  },
  author: {
    fieldText: 'Author',
  },
  illustrator: {
    fieldText: 'Illustrator',
  },
  dateAdded: {
    fieldText: 'Date Added',
    formatData: (cell) => momentDatetime(cell).format('dddd Do MMMM, YYYY'),
  },
  moderated: {
    fieldText: 'Moderated',
  },
  status: {
    fieldText: 'Status',
    formatData: (cell) => (
      <span
        className={classNames({
          'text-bold': true,
          'text-capitalize': true,
          'text-green': cell === 'public',
          'text-red': cell === 'pending',
        })}
      >
        {cell}
      </span>
    ),
  },
  addedBy: {
    fieldText: 'Added By',
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row) => (
      <Link to={`/books/${row.id}`} title="view">
        <RemoveRedEyeIcon />
      </Link>
    ),
  },
});

class BookTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
    hiddenFields: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      bookToDelete: {},
    };
    this.sortingManager = new SortingManager();
  }

  render() {
    const {recordPages, onSortableFieldClick, hiddenFields} = this.props;
    const books = recordPages[recordPages.currentPage] || {};
    const records = buildBookRecords(books);
    const settings = buildBookSettings();
    return (
      <KluwellTableCore
        {...{
          records,
          settings,
          sortingManager: this.sortingManager,
          onSortableFieldClick,
          hiddenFields,
        }}
      />
    );
  }
}

export default withKluwellTableWrapper(BookTableCore);
